import React from 'react';
import { ReactComponent as Calendar } from '../../assets/images/icons/calendar.svg';

export default function CalendarIcon(props) {
  return (
    <Calendar className={`icon ${props.className}`} />
  );
}
